import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Item, ItemActions, ItemContent, ItemDescription, ItemTitle } from '@/components/ui/item';

interface Props {
  onAuthClick: () => void;
  disabled?: boolean;
}

export const ConnectCard = ({ onAuthClick, disabled }: Props) => {
  const { t } = useTranslation();

  return (
    <Item variant="outline">
      <ItemContent>
        <ItemTitle>{t('integrations.intercom.redirect_title')}</ItemTitle>
        <ItemDescription className="line-clamp-none text-sm leading-5 font-normal text-wrap text-muted-foreground">
          {t('integrations.intercom.redirect_subtitle')}
        </ItemDescription>
      </ItemContent>
      <ItemActions>
        <Button onClick={onAuthClick} disabled={disabled}>
          {t('integrations.intercom.redirect_connect')}
        </Button>
      </ItemActions>
    </Item>
  );
};
